import { z } from 'zod';

export type ResultsVenueMonthDto = z.infer<typeof resultsVenueMonthDtoSchema>;

export type ResultsVenueScoresObjectDto = z.infer<typeof scoresObjectSchema>;

export const scoresObjectSchema = z.object({
  co2: z.object({
    score: z.number(),
  }),
  env: z.object({
    score: z.number(),
    maxScore: z.number(),
  }),
  ess: z.object({
    score: z.number(),
    maxScore: z.number(),
    stats: z
      .object({
        totalMen: z.number(),
        totalWomen: z.number(),
        totalOther: z.number(),
      })
      .optional(),
  }),
});

const monthKeyType = z.string().regex(/^\d{1,2}$/);
const yearKeyType = z.string().regex(/^\d{4}$/);

export const resultsVenueMonthDtoSchema = z.object({
  months: z.record(yearKeyType, z.record(monthKeyType, scoresObjectSchema)),
  dates: z.array(
    z.object({
      id: z.number(),
      name: z.string(),
      startDate: z.string(),
      results: scoresObjectSchema,
    }),
  ),
});
